import React from 'react';

const TabNavigation = ({ tabs, activeTab, onTabChange, className = '', vertical = false, boxedActive = false }) => {
  if (vertical) {
    return (
      <div className={`flex flex-col gap-0.5 pr-4 border-r border-gray-200 dark:border-gray-700 min-w-[160px] ${className}`}>
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          const isDisabled = tab.disabled;

          return (
            <button
              key={tab.id}
              onClick={() => !isDisabled && onTabChange(tab.id)}
              disabled={isDisabled}
              title={tab.name}
              className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 text-left w-full
                ${isDisabled
                  ? 'text-gray-400 dark:text-gray-600 cursor-not-allowed'
                    : isActive
                    ? `bg-gray-100 dark:bg-slate-700 ${boxedActive ? 'border border-gray-200 shadow-sm dark:border-slate-600' : ''}`
                    : 'text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800'
                }`}
              style={isActive
                ? { borderLeft: '3px solid var(--app-primary-color, #26256b)', paddingLeft: '9px', color: 'var(--app-primary-color, #26256b)' }
                : { borderLeft: '3px solid transparent', paddingLeft: '9px' }}
            >
              {Icon && (
                <Icon className={`w-4 h-4 flex-shrink-0 ${isActive ? '' : 'text-gray-400'}`}
                  style={isActive ? { color: 'var(--app-primary-color, #26256b)' } : {}} />
              )}
              <span>{tab.name}</span>
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className={`flex gap-1 mb-6 border-b border-gray-200 dark:border-gray-700 pb-1 overflow-x-auto ${className}`} style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        const isDisabled = tab.disabled;

        return (
          <button
            key={tab.id}
            onClick={() => !isDisabled && onTabChange(tab.id)}
            disabled={isDisabled}
            title={tab.name}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap flex-shrink-0
              ${isDisabled
                ? 'text-gray-400 dark:text-gray-600 cursor-not-allowed'
                : isActive
                  ? `bg-gray-100 dark:bg-slate-700 ${boxedActive ? 'border border-gray-200 shadow-sm dark:border-slate-600' : ''}`
                  : 'text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800'
              }`}
            style={isActive ? { color: 'var(--app-primary-color, #26256b)' } : {}}
          >
            {Icon && (
              <Icon className={`w-4 h-4 flex-shrink-0 ${isActive ? '' : 'text-gray-400'}`}
                style={isActive ? { color: 'var(--app-primary-color, #26256b)' } : {}} />
            )}
            <span>{tab.name}</span>
          </button>
        );
      })}
    </div>
  );
};

export default TabNavigation;
